<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              class="hidden-sm-and-down"
              ></v-text-field>     
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <router-link :to="{path: formPath}">
                  <v-btn color="success" fab small dark>
                    <v-icon>add</v-icon>
                  </v-btn>  
              </router-link>              
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                select-all                
                v-model="complex.selected"
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    v-model="props.selected"
                  ></v-checkbox>
                </td>              
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.description }}</td>                
                  <td>
                    <router-link :to="{path:viewPath, query: {id: props.item.id}}">
                        <v-btn depressed outline icon fab dark color="teal" small>
                            <v-icon>opacity</v-icon>
                        </v-btn>
                    </router-link>                      
                                          
                    <router-link :to="{path:formPath, query: {id: props.item.id}}">
                        <v-btn depressed outline icon fab dark color="primary" small>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </router-link>                      
                    <v-btn @click="remove(props)" depressed outline icon fab dark color="pink" small>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Permission   from '@/apps/main/models/rbac/Permission';    
import moment       from 'moment';

var model = new Permission();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        formPath : '/rbac/permissions/form',
        viewPath : '/rbac/permissions/view',
        search   : '',
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [                            
              { text: 'Name', value: 'name'},              
              { text: 'Description', value: 'description'},              
              { text: 'Action', value: '', align:'left' },              
            ],
            items: []
        },
    }),  
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {
                data.forEach((item, index)=>{
                    data[index].id = item.name;
                });
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },
                
        remove(props = {}, all = false){
            this.$swal({
                title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',
                showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
            }).then((result) => {                 
                if (result.value) {                    
                    if(!all){
                        model.delete(props.item, {id:props.item.id}).then( res => {
                            if(res.status === 200){                   
                                this.$swal('Deleted!', 'Your file has been deleted.', 'success');       
                                this.init();
                            } else {
                                var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                                var text  = res.statusText ? res.statusText:
                                    'Something happened in setting up the request that triggered an Error.'; 
                                this.$swal({type: 'error', title: title, text: text});                                        
                            }
                        });
                    } else {                        
                        this.complex.selected.forEach((value, key) => {model.delete(value);});
                        this.$swal('Deleted!', 'Your file has been deleted.', 'warning').then(res => {this.init()});                                                           
                    }
                }
            });
        },
                        
        resolve(props){
            let info = props.item.info;
            if( info.action == 'synch' ){                
                this.$router.push({path:'/accounting/acc-periode/form', query: {id: props.item.id}}); 
            } else if(info.action == 'fetch') {                
                window.getApp.$emit('APP_OPEN_FETCH', props);
            }            
        }
    }
}
</script>